import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { login } from "../../redux/user/login.handler";
import { useNavigate } from "../../hooks/navigate";
import { AppContext } from "../../components/Menu/MenuButton";
import styles from "./LogoPage.module.scss";
import { TAdv } from "../../redux/app.slice";
import { setAppContext } from "../../redux/app.slice";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { useTracking } from "../../hooks/traking";
import { ISessionInfo } from "../../types/session";
import { getChallenges } from "../../redux/challenges/get-challenges.handler";
import { getPlatform, getPlatformTitle, Platform } from "../../platform/platform";
import { resolveInitDataForLogin } from "../../platform/resolve-init-data";

const isDevEnv = process.env.REACT_APP_ENV === "DEV";

export const LogoPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const shouldLogin = useRef(true);
    const [platformTitle, setPlatformTitle] = useState<string>(() => getPlatformTitle(getPlatform()));

    const { id: userId, isFirstLaunch, error } = useSelector(store => store.user.info);
    const { inited, adv, clientId, ymState, yclid, ref } = useSelector(store => store.appData);
    const { trackCustom } = useTracking('App');

    useEffect(() => {
        setPlatformTitle(getPlatformTitle(getPlatform()));
    }, []);

    useEffect(() => {
        if (!shouldLogin.current)
            return;

        if (inited === false)
            return;

        const platform = getPlatform();
        const initDataRaw = resolveInitDataForLogin(platform);
        if (platform === Platform.Max && !initDataRaw)
            return;

        shouldLogin.current = false;
        dispatch(login({ initData: initDataRaw, clientId, yclid, ref }));
    }, [dispatch, ymState, clientId, inited, yclid, ref]);

    useEffect(() => {
        if (!userId)
            return;
        
        // костыль
        setTimeout(() => {
            if (isFirstLaunch === undefined)
                return;

            if (!isFirstLaunch)
                navigate(AppContext.Office)

            let context: AppContext;
            switch (adv) {
                case TAdv.Draw: context = AppContext.Draw; break;
                case TAdv.Game: context = AppContext.Office; break;
                default: context = AppContext.Draw;
            }

            trackCustom('start');
            const sessionInfo: ISessionInfo = {
                start: new Date().getTime()
            }
            localStorage.setItem('sessionInfo', JSON.stringify(sessionInfo));

            dispatch(getChallenges());
            dispatch(setAppContext(context));
            navigate(context, {
                state: {
                    isFirstPage: true,
                }
            });
        }, 400);
    }, [dispatch, navigate, userId, isFirstLaunch, adv, trackCustom]);

    return (
        <>
            <div className={ styles.imageCont } >
                <img
                    src="/img/bl-app-logo.jpg"
                    alt="logo"
                    className={ styles.image }
                />
                { isDevEnv && (
                    <p className={ styles.platformText }>
                        { platformTitle }
                    </p>
                ) }
            </div>
            { error && error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}